import React from 'react';
import Hero from './Hero';
import About from './About';
import Features from './Features';
import Menu from './Menu';
import FirmVisit from './FirmVisit';
import Testimonials from './Testimonials';
import Blog from './Blog';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Features />
      <Menu />
      <Testimonials />
    </>
  );
};

export default Home;